import Svg, { Circle, Ellipse, Path } from 'react-native-svg';
import { TIllustrationProps } from '@/common/components/Illustrations/types';

export function IllustrationNetwork({
  width = 117,
  height = 110,
  className,
}: TIllustrationProps) {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 117 110"
      fill="none"
      className={className}
    >
      <Ellipse cx={92.166} cy={61.105} fill="#F7F8FA" rx={24.797} ry={7.715} />
      <Path
        fill="#C4E8E4"
        d="M77.838 47.322c-7.606-7.607-7.607-19.94 0-27.547 7.607-7.607 19.94-7.607 27.548 0 7.607 7.607 7.607 19.94 0 27.547l-.187.185L91.61 61.096 77.928 47.414l.001-.002-.09-.09Z"
      />
      <Path fill="#8E9CAB" d="M90.175 20.456h1.743v5.153h-1.743z" />
      <Path
        fill="#8E9CAB"
        d="M91.409 25.062c.584-1.812 2.874-4.843 7.367-2.476-.362 1.53-2.343 4.167-7.367 2.476Z"
      />
      <Circle
        cx={88.985}
        cy={34.033}
        r={9.203}
        fill="#FFE5D8"
        transform="rotate(-165 88.985 34.033)"
      />
      <Circle
        cx={93.747}
        cy={34.035}
        r={9.203}
        fill="#FF8E7A"
        transform="rotate(-165 93.747 34.035)"
      />
      <Ellipse cx={37.613} cy={83.146} fill="#fff" rx={37.471} ry={13.225} />
      <Path
        fill="#A6DDD6"
        d="M17.776 65.511c-10.956-10.955-10.956-28.718 0-39.674s28.719-10.956 39.675 0c10.955 10.956 10.955 28.719 0 39.675-.016.014-.03.03-.046.045l.002.001-19.793 19.793-19.705-19.705.001-.001-.134-.133Z"
      />
      <Path
        fill="#FF8E7A"
        d="M52.38 35.745c1.755 2.748.235 6.548-3.04 7.016h-.701a5.037 5.037 0 0 1-3.801-1.696 5.037 5.037 0 0 1-3.8 1.696c-1.52 0-2.924-.643-3.86-1.696-.877 1.053-2.28 1.696-3.8 1.696a5.037 5.037 0 0 1-3.8-1.696 5.037 5.037 0 0 1-3.802 1.696h-.701c-3.274-.468-4.795-4.268-3.04-7.017l3.332-5.262a1.575 1.575 0 0 1 1.403-.818h20.875c.584 0 1.11.292 1.403.818l3.333 5.263Z"
      />
      <Path
        fill="#fff"
        d="M50.336 44.457a2.962 2.962 0 0 1-.76.117c-.293.058-.644.058-.936.058-.702 0-1.403-.058-2.047-.292v7.776h-18.71V44.34c-.702.234-1.404.292-2.105.292-.351 0-.643 0-.936-.058a2.18 2.18 0 0 1-.701-.117v11.402c0 2.105 1.637 3.742 3.742 3.742h18.71a3.73 3.73 0 0 0 3.742-3.742V44.457Z"
      />
    </Svg>
  );
}
